import React, { useState, useEffect } from 'react';
import { Card, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { CHUYENNGANH_API, NGANH_API } from '@app/utils/apiUrl';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { Get, Post } from '@app/utils/httpProvider';
import { messageError, messageToast, status200, styleSelectDefault } from '../../../../utils/define';
import { URI_INTERNAL } from '../../../../utils/pathLocations';
import { Button } from '@components';
import { AsyncPaginate } from 'react-select-async-paginate';
import HorizontalFieldsRow from '@app/components/common/HorizontalFieldsRow';
import Editor from '@app/components/editor/Editor';

const schema = yup.object().shape({
    nganhId: yup.object().nullable().required('Ngành không được để trống'),
    maChuyenNganh: yup.string().required(messageError.emptyMessage).max(50, 'Mã chuyên ngành tối đa 50 ký tự'),
    tenChuyenNganh: yup.string().required(messageError.emptyMessage).max(255, 'Tên chuyên ngành tối đa 255 ký tự')
});

const ChuyenNganhAdd = () => {
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const [nganhOptions, setNganhOptions] = useState([]);

    const addFunc = useMutation((value) =>
            Post(CHUYENNGANH_API.ADD_ITEM, null, value, false)
        );

    const handleCreate = async (values) => {
        setIsLoading(true);
        const model = values;

        model.nganhId =
            values.nganhId === '' ||
                values.nganhId === 'null' ||
                values.nganhId === undefined
                ? ''
                : values.nganhId.value;

        addFunc.mutate(model, {
            onSuccess: (res) => {
                if (res.status !== status200) {
                    toast.error(messageToast.messageToastCreateError);
                } else {
                    setIsLoading(false);
                    toast.success(messageToast.messageToastCreateSuccess);
                    history.goBack();
                }
            },
            onError: (res) => {
                toast.error(
                    res.message || 'Đã có lỗi xảy ra, vui lòng thử lại !'
                );
            }
        });
    };

    const loadOptionsNganh = async (search, loadedOptions, { page }) => {
        const pageSize = 10;
        const res = await Get(NGANH_API.GET_PAGING, null, {
            PageIndex: page,
            PageSize: pageSize,
            Keyword: search // pass the input text to filter server-side
        });

        const data = res.data || [];
        const options = data.map((x) => ({
            label: `${x.maNganh} - ${x.tenNganh}`,
            value: x.id
        }));

        // assume your API returns total count or a flag for more pages
        const hasMore = data.length === pageSize;
        return {
            options,
            hasMore,
            additional: { page: page + 1 }
        };
    };

    return (
        <Card>
            <Card.Header as="h5">Thêm mới chuyên ngành</Card.Header>
            <Card.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={(values) => handleCreate(values)}
                    initialValues={{
                        nganhId: '',
                        maChuyenNganh: '',
                        tenChuyenNganh: '',
                        moTa: ''
                    }}
                >
                    {({ handleSubmit, handleChange, values, errors, setFieldValue }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <HorizontalFieldsRow
                                fields={[
                                    {
                                        label: 'Mã chuyên ngành',
                                        name: 'maChuyenNganh',
                                        value: values.maChuyenNganh,
                                        onChange: handleChange,
                                        isInvalid: errors.maChuyenNganh,
                                        error: errors.maChuyenNganh
                                    },
                                    {
                                        label: 'Tên chuyên ngành',
                                        name: 'tenChuyenNganh',
                                        value: values.tenChuyenNganh,
                                        onChange: handleChange,
                                        isInvalid: errors.tenChuyenNganh,
                                        error: errors.tenChuyenNganh
                                    },
                                ]}
                            />
                            <Row>
                                <Col md={6}>
                                    <Form.Group as={Row} className="mb-3">
                                        <Form.Label className="col-sm-3 col-form-label">
                                            Ngành
                                        </Form.Label>
                                        <Col sm="9">
                                            <AsyncPaginate
                                                name="nganhId"
                                                id="nganhId"
                                                placeholder="Chọn ngành"
                                                value={values.nganhId}
                                                loadOptions={loadOptionsNganh}
                                                styles={styleSelectDefault}
                                                isClearable
                                                onChange={(selectedOption) => {
                                                    // const event = {
                                                    //     target: {
                                                    //         name: 'accountPatients',
                                                    //         value: selectedOption
                                                    //     }
                                                    // };
                                                    // setAccountHisId(event);
                                                    setFieldValue(
                                                        'nganhId',
                                                        selectedOption,
                                                        true
                                                    );
                                                }}
                                                additional={{
                                                    page: 1
                                                }}
                                            />
                                            <div
                                                style={{
                                                    display: 'block',
                                                    color: '#dc3545'
                                                }}
                                                className="invalid-feedback"
                                            >
                                                {errors.nganhId}
                                            </div>
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group as={Row} className="mb-3">
                                        <Form.Label className="col-sm-2 col-form-label">
                                            Mô tả
                                        </Form.Label>
                                        <Col sm="10">
                                            <Col sm="10">
                                                <Editor
                                                    name="moTa"
                                                    value={values.moTa}
                                                    onChange={(value) => {
                                                        setFieldValue(
                                                            'moTa',
                                                            value
                                                        );
                                                    }}
                                                />
                                            </Col>
                                        </Col>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Form.Group as={Row} className="mb-3">
                                <Col md={{ span: 10, offset: 2 }}>
                                    <ButtonGroup className="mb-2">
                                        <Button type="submit" theme="primary" disabled={isLoading}>
                                            Thêm
                                        </Button>
                                        &nbsp;&nbsp;&nbsp;
                                        <Button onClick={() => history.push(URI_INTERNAL.CHUYENNGANH_PATH)} theme="secondary">
                                            Hủy
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Form.Group>
                        </Form>
                    )}
                </Formik>
                {isLoading && <div>Đang lưu...</div>}
            </Card.Body>
        </Card>
    );
};

export default ChuyenNganhAdd;
